module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-report-5.30c6d442.svg";